<template>
    <tq-loader-container :p_show-loader_b="showPageLoader_b" :p_tq-loader_b="true" >
        <div v-if="!showPageLoader_b" class="TQ_center">

            <!-- 1) user info -->
            <div v-if="(p_fbAuth_c || loginWithGuest_b) && !p_upgradeUser_b">

                <!-- 1.1) Title -->
                <div class="TQ_border_bottom_gray TQ_borderRadius_top  TQ_direction_ltr TQ_text_16px TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_text_capitalize TQ_margin_bottom_8px">
                    <div class="TQ_width_24px TQ_margin_4px TQ_grid_center" >
                        <tq-image :pb_src_r="ass_img_arrow_left_b" class="TQ_width_100p TQ_margin_top_4px TQ_clickable"
                                  v-if="loginWithGuest_b"
                                  @click.native="loginWithGuest_b=false"/>
                    </div>
                    <div class="TQ_padding_8px TQ_grid_center">
                        {{ ass_strings.oneWord_login[p_system_langCode_e] }} {{ass_strings.oneWord_or[p_system_langCode_e]}} {{ ass_strings.twoWords_signUp[p_system_langCode_e] }}
                    </div>
                    <div class="TQ_width_24px TQ_margin_4px TQ_grid_center" >

                    </div>
                </div>

                <!-- 1.2) avatar -->
                <tq-avatar :p_ud_avatar_c="avatar_c"
                           v-if="avatar_c"
                           @click.native="popup_show_avatar_generator_vb.val=true"
                           class="TQ_width_100px TQ_padding_8px TQ_bg_white TQ_bg_circle TQ_box_shadow TQ_clickable TQ_border_darkGray TQ_margin_16px"/>

                <!-- 1.3) username -->
                <div class="TQ_margin_0_16px" >
                    <div class="TQ_align_initial TQ_text_capitalize_first_letter">
                        {{ass_strings.fourWords_EnterYourFullName[p_system_langCode_e]}}
                    </div>
                    <fc-error-input
                        class="TQ_width_100p "
                        :p_input-class_s="'TQ_fullScreen TQ_center TQ_padding_8px TQ_text_20px TQ_border_darkGray TQ_borderRadius TQ_direction_ltr '"
                        :p_input-type_s="enum_inputType.text_s"
                        :p_val_o="username_s"
                        :p_placeholder_s="ass_strings.twoWords_fullName[p_system_langCode_e]"
                        :p_error_s="co_checkInput_username_s"
                        :pe_input_f="val => username_s = val"/>

                </div>
                <div class="TQ_padding_2px"></div>

                <!-- 1.4) TOS -->
                <div class="TQ_grid_col_auto1fr TQ_grid_gap_8px TQ_margin_16px ">
                    <tq-checkbox :p_checked_b="agreeToTos_b" @click.native="agreeToTos_b = !agreeToTos_b"
                                 class="TQ_width_28px TQ_grid_verticalCenter TQ_box_shadow TQ_border_darkGray"/>
                    <span class="TQ_text_16px TQ_align_initial TQ_grid_verticalCenter TQ_text_capitalize_first_letter">

                        {{ ass_strings.threeWords_iAgreeTo[p_system_langCode_e] }}

                        <tq-link class="TQ_link" :p_link_s="enum_moveToOptions.terms_termsOfUse">{{ ass_strings.threeWords_termsOfUse[p_system_langCode_e] }}</tq-link>,

                        <tq-link class="TQ_link" :p_link_s="enum_moveToOptions.terms_privacyPolicy">{{ ass_strings.twoWords_privacyPolicy[p_system_langCode_e] }}</tq-link>,
                        {{ ass_strings.oneWord_and[p_system_langCode_e] }}

                        <tq-link class="TQ_link" :p_link_s="enum_moveToOptions.terms_creatorPolicy">{{ ass_strings.twoWords_creatorPolicy[p_system_langCode_e] }}</tq-link>

                    </span>
                </div>

                <!-- 1.4) btns  -->
                <div class="TQ_margin_bottom_16px TQ_margin_0_16px ">

                    <!-- continue -->
                    <div @click="m_userInfo_clickContinue_f" class="TQ_grid_col_1frAuto TQ_bg_purple_lite TQ_bg_gray4 TQ_padding_8px  TQ_borderRadius TQ_box_shadow TQ_text_20px TQ_width_100p TQ_borderBox TQ_clickable">
                        <div class="TQ_grid_verticalCenter">{{ass_strings.oneWord_Continue[p_system_langCode_e]}}</div>

                        <div class="TQ_grid_verticalCenter TQ_animation_beacon TQ_square_8px TQ_bg_circle" v-if="co_checkInput_username_s == null && agreeToTos_b"></div>
                    </div>

                </div>

            </div>

            <!-- 2) email -->
            <div v-else-if="loginWithEmail_b">

                <!-- 2.1) Title -->
                <div class="TQ_border_bottom_gray TQ_borderRadius_top  TQ_direction_ltr TQ_text_16px TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_text_capitalize TQ_margin_bottom_8px">
                    <div class="TQ_width_24px TQ_margin_4px TQ_grid_center" >
                        <tq-image :pb_src_r="ass_img_arrow_left_b" class="TQ_width_100p TQ_margin_top_4px TQ_clickable"
                                  @click.native="m_login_email_backBtn_f"/>
                    </div>
                    <div class="TQ_padding_8px TQ_grid_center">
                        {{ ass_strings.oneWord_login[p_system_langCode_e] }} {{ass_strings.oneWord_or[p_system_langCode_e]}} {{ ass_strings.twoWords_signUp[p_system_langCode_e] }}
                    </div>
                    <div class="TQ_width_24px TQ_margin_4px TQ_grid_center" >

                    </div>
                </div>

                <!-- 2.2) Text -->
                <div class="TQ_padding_16px TQ_text_20px TQ_text_bold TQ_align_initial">
                    <div v-if="!lastProviders_ae">
                        {{ass_strings.fourWords_EnterYourEmailAddress[p_system_langCode_e]}}
                    </div>
                    <div v-else>
                        {{ass_strings.fourWords_pleaseEnterYourPassword[p_system_langCode_e]}}
                    </div>

                </div>

                <!-- 2.3) Email -->
                <div class="TQ_margin_0_16px TQ_margin_bottom_16px TQ_borderRadius " >

                    <fc-error-input
                        class="TQ_width_100p"
                        :p_input-class_s="'TQ_fullScreen TQ_center TQ_padding_8px TQ_text_20px TQ_direction_ltr TQ_border_darkGray TQ_borderRadius' + (lastProviders_ae ? ' TQ_bg_gray3' : ' ')"
                        :p_input-type_s="enum_inputType.email_s"
                        :p_val_o="email_s"
                        :p_placeholder_s="ass_strings.oneWord_email[p_system_langCode_e]"
                        :p_error_s="co_checkInput_email_s"
                        :p_disable_b="lastProviders_ae != null"
                        :pe_input_f="val => email_s = val"/>

                    <!--<tq-image :pb_src_r="ass_img_mail_w"-->
                    <!--          class="TQ_height_40px TQ_width_40px TQ_grid_center TQ_padding_12px TQ_bg_purple_dark TQ_borderBox TQ_borderRadius_left"-->
                    <!--          :class="co_langCodeRtl_b ? 'TQ_borderRadius_left' : 'TQ_borderRadius_right'"/>-->

                </div>

                <!-- 2.4) Password -->
                <div class="TQ_margin_0_16px TQ_margin_bottom_8px"  >
                    <div v-if="lastProviders_ae">
                        <!-- input -->
                        <div class="TQ_grid_col_1frAuto TQ_borderRadius">

                            <fc-error-input
                                :p_input-class_s="'TQ_fullScreen TQ_center TQ_padding_8px TQ_text_20px TQ_borderRadius TQ_border_darkGray TQ_direction_ltr '" :p_input-type_s="enum_inputType.text_s"
                                :p_val_o="password_s"
                                :p_placeholder_s="ass_strings.oneWord_password[p_system_langCode_e]"
                                :p_error_s="co_checkInput_password_fs"
                                :pe_input_f="val => password_s = val"/>

                        </div>

                        <!-- forgot password -->
                        <div class="TQ_align_end" v-if="lastProviders_ae.includes(enum_loginMethods.email)">
                            <div class="TQ_padding_4px TQ_inline TQ_text_14px TQ_clickable TQ_link TQ_text_bold TQ_text_capitalize"
                                 @click="popup_show_forgotPassword_vb.val = true">
                                {{ass_strings.twoWords_forgotPassword[p_system_langCode_e]}}?
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 2.5) Login Btn  -->
                <div class="TQ_margin_16px">
                    <div class="TQ_bg_purple_lite TQ_box_shadow TQ_borderRadius TQ_padding_8px TQ_clickable TQ_width_100p TQ_borderBox  TQ_text_20px"
                         @click="m_login_email_f()">
                        {{ass_strings.oneWord_Continue[p_system_langCode_e]}}
                    </div>
                </div>

            </div>

            <!-- 3) login options -->
            <div v-else>

                <!-- 3.1) Title -->
                <div class="TQ_border_bottom_gray TQ_margin_bottom_16px TQ_borderRadius_top TQ_padding_16px TQ_direction_ltr TQ_text_16px TQ_text_capitalize">
                    {{ ass_strings.oneWord_login[p_system_langCode_e] }} {{ass_strings.oneWord_or[p_system_langCode_e]}} {{ ass_strings.twoWords_signUp[p_system_langCode_e] }}
                </div>

                <!-- 3.2) welcome text -->
                <div class="TQ_padding_8px TQ_text_20px TQ_text_bold">
                    {{ass_strings.fourWords_welcomeToTravelQuest[p_system_langCode_e]}}
                </div>

                <!-- 3.3) more login options -->
                <div class="TQ_padding_16px TQ_text_capitalize">

                    <!-- google  -->
                    <div v-if="!p_hideLoginOption_ae.includes(enum_loginMethods.google)"
                        class="TQ_align_initial TQ_grid_col_auto1fr TQ_grid_gap_32px TQ_clickable TQ_box_shadow TQ_padding_12px TQ_margin_bottom_16px TQ_border TQ_borderRadius"
                         @click="m_login_google_f">

                        <tq-image :pb_src_r="ass_img_google_c" class="TQ_width_24px TQ_grid_verticalCenter"/>

                        <div class=" TQ_grid_verticalCenter TQ_text_20px">
                            {{ass_strings.fourWords_signInWithGoogle[p_system_langCode_e]}}
                        </div>
                    </div>

                    <!-- facebook -->
                    <div v-if="!p_hideLoginOption_ae.includes(enum_loginMethods.facebook)" class="TQ_align_initial TQ_grid_col_auto1fr TQ_grid_gap_32px TQ_clickable  TQ_box_shadow TQ_padding_12px TQ_border TQ_borderRadius TQ_margin_bottom_16px"
                         @click="m_login_facebook_f">
                        <tq-image :pb_src_r="ass_img_facebook_c" class="TQ_width_24px TQ_grid_verticalCenter "/>

                        <div class="TQ_grid_verticalCenter TQ_text_20px">
                            {{ass_strings.fourWords_signInWithFacebook[p_system_langCode_e]}}
                        </div>
                    </div>

                    <!-- email and pass -->
                    <div v-if="!p_hideLoginOption_ae.includes(enum_loginMethods.email)" class="TQ_align_initial TQ_grid_col_auto1fr TQ_grid_gap_32px TQ_clickable TQ_box_shadow TQ_padding_12px TQ_borderRadius TQ_border TQ_margin_bottom_16px"
                         @click="loginWithEmail_b=true">
                        <tq-image :pb_src_r="ass_img_mail_b2" class="TQ_width_24px TQ_grid_verticalCenter "/>
                        <div class="TQ_grid_verticalCenter TQ_text_20px ">
                            {{ass_strings.fourWords_signInWithEmail[p_system_langCode_e]}}
                        </div>
                    </div>

                    <!-- guest -->
                    <div v-if="p_showGuestOption_b && !p_hideLoginOption_ae.includes(enum_loginMethods.guest)" class="TQ_grid_col_auto1fr TQ_grid_gap_32px TQ_clickable TQ_box_shadow TQ_padding_12px TQ_border TQ_borderRadius "
                         @click="loginWithGuest_b=true">
                        <tq-image :pb_src_r="ass_img_user_b" class="TQ_width_24px TQ_grid_verticalCenter "/>
                        <div class="TQ_align_initial TQ_grid_verticalCenter TQ_text_20px">
                            {{ass_strings.fourWords_signInAsGuest[p_system_langCode_e]}}
                        </div>
                    </div>

                </div>

            </div>

            <!-- 4) popups -->
            <div>
                <!-- 5.1) forgot password-->
                <tq-popup :show="popup_show_forgotPassword_vb" padding="0" max-width="350px" :show-close-btn="true">

                    <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_20px TQ_text_capitalize">
                        {{ass_strings.twoWords_forgotPassword[p_system_langCode_e]}}
                    </div>


                    <div class="TQ_padding_8px">
                    </div>

                    <div class="TQ_margin_16px TQ_grid_col_1frAuto TQ_borderRadius " >
                        <fc-error-input
                            :p_input-class_s="'TQ_fullScreen TQ_center TQ_padding_8px TQ_text_20px TQ_border_none TQ_direction_ltr ' + (co_langCodeRtl_b ? 'TQ_borderRadius_right' : 'TQ_borderRadius_left')"                            :p_input-type_s="enum_inputType.email_s"
                            :p_val_o="email_s"
                            :p_placeholder_s="ass_strings.oneWord_email[p_system_langCode_e]"
                            :p_error_s="co_checkInput_email_s"
                            :pe_input_f="val => email_s = val"/>

                        <tq-image :pb_src_r="ass_img_mail_w"
                                  :class="co_langCodeRtl_b ? 'TQ_borderRadius_left' : 'TQ_borderRadius_right'"
                                  class="TQ_height_40px TQ_width_40px TQ_grid_center TQ_padding_12px TQ_bg_purple_dark TQ_borderBox TQ_borderRadius_left"/>

                    </div>

                    <div class="TQ_padding_4px">
                    </div>

                    <tq-btn-approve
                        class="TQ_inline"
                        :system-lang-code="p_system_langCode_e"
                        :popup-text="ass_strings.question_resetPass"
                        :approve-cb="m_login_email_resetPass_f">
                        <div class="TQ_padding_8px TQ_bg_purple_lite TQ_borderRadius TQ_margin_16px TQ_borderBox TQ_box_shadow TQ_clickable">
                            {{ass_strings.threeWords_sendResetLink[p_system_langCode_e]}}
                        </div>
                    </tq-btn-approve>




                </tq-popup>

                <!-- 5.2) popup - notification reset email -->
                <tq-popup :show="popup_show_notificationResetEmail_vb" max-width="350px" :show-close-btn="true" padding="0px">

                    <div class="TQ_text_20px TQ_text_bold TQ_bg_purple_dark TQ_padding_12px TQ_text_capitalize">
                        {{ ass_strings.fourWords_checkYourEmailAddress[p_system_langCode_e] }}
                    </div>

                    <div class="TQ_padding_16px">
                        {{ ass_strings.sentence_weSentEmail1[p_system_langCode_e] }},
                        {{ass_strings.sentence_weSentEmail2[p_system_langCode_e]}}.
                    </div>

                    <hr class="TQ_margin_bottom_-4px">

                    <div class="TQ_padding_8px TQ_align_end">

                        <div class="TQ_width_100px TQ_bg_purple_lite TQ_padding_8px TQ_box_shadow TQ_inline TQ_borderRadius TQ_width_56px TQ_center TQ_clickable"
                             @click="popup_show_notificationResetEmail_vb.val = false">
                            {{ ass_strings.oneWord_approve[p_system_langCode_e] }}
                        </div>
                    </div>
                </tq-popup>

                <!-- 5.3) popup - generate avatar popup-->
                <tq-popup :show="popup_show_avatar_generator_vb" max-width="750px" padding="0" :show-close-btn="true">
                    <div class="TQ_text_24px TQ_bg_purple_dark TQ_padding_12px TQ_border_bottom TQ_text_capitalize">
                        {{ass_strings.threeWords_chooseYourAvatar[p_system_langCode_e]}}
                    </div>

                    <!-- Pure choose avatar-->
                    <fcpc-avatar-generator class="TQ_margin_0_4px"
                                           :pp_get-file_vf="getFile_vf"
                                           :p_ud_avatar_c="avatar_c" :p_system_lang-code_e="p_system_langCode_e"/>

                    <!-- btns -->
                    <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_border_top " >
                        <div @click="popup_show_avatar_generator_vb.val=false"
                             class="TQ_inline TQ_bg_red TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_width_72px TQ_clickable">
                            {{ass_strings.oneWord_cancel[p_system_langCode_e]}}
                        </div>
                        <div></div>
                        <div @click="m_avatarPopup_clickTheApproveBtn_f"
                             class="TQ_inline TQ_bg_purple_dark TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_width_72px TQ_clickable">
                            {{ass_strings.oneWord_approve[p_system_langCode_e]}}
                        </div>
                    </div>
                </tq-popup>

                <!-- 5.4) popup - login with google -->
                <tq-popup :show="popup_show_loginWithProviderNotice_vb" max-width="350px" padding="0px" :show-close-btn="true">
                    <div class="TQ_text_24px TQ_bg_purple_dark TQ_padding_8px TQ_border_bottom TQ_text_capitalize">
                        {{ass_strings.oneWord_notice[p_system_langCode_e]}}
                    </div>

                    <!-- body -->
                    <div class="TQ_padding_8px TQ_text_20px TQ_text_capitalize_first_letter">
                        {{ass_strings.sentenceGroup_userGoogleExist1[p_system_langCode_e]}}.
                    </div>

                    <div class="TQ_padding_8px TQ_border_top TQ_align_end">
                        <div @click="m_login_google_f"
                             class="TQ_center TQ_inline TQ_padding_8px TQ_bg_purple_lite TQ_box_shadow TQ_borderRadius TQ_clickable TQ_width_72px">
                            {{ass_strings.oneWord_Continue[p_system_langCode_e]}}
                        </div>
                    </div>
                </tq-popup>
            </div>

        </div>
    </tq-loader-container>
</template>

<script>

import {
    serverAuth_resetPassword_fp,
    serverAuth_login_guest_fp,
    serverAuth_login_google_fp,
    serverAuth_login_emailPass_fp,
    serverAuth_login_facebook_fp,
    serverAuth_linkEmailPass_fp,
    serverAuth_fetchProvidersForEmail_fp, serverAuth_currentUserData_update_f,
} from "@/scripts/Server/S_ServerAuth";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {notification_notify2} from "@/scripts/S_Notification";
import {
    ass_img_facebook_w,
    ass_img_google_w,
    ass_img_arrow_left_w,
    ass_img_lock_w,
    ass_img_mail_w,
    ass_img_user_w,
    ass_img_google_c,
    ass_img_facebook_c,
    ass_img_mail_b,
    ass_img_mail_b2,
    ass_img_user_b,
    ass_img_arrow_left_b
} from "@/assets/scripts/Ass_Files";
import {
    enum_loginErrors,
    enum_inputType,
    enum_langCodes, enum_loginMethods,
    enum_moveToOptions, enum_directions
} from "../../../functions/src/shareCode/Share_S_Enum";

    import TqImage from "@/components/basic/TqImage";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
import TqAvatar from "@/components/complex/TqAvatar";
import TqPopup from "@/components/basic/TqPopup";
import {
    FB_UserData_Avatar,
    FB_FbAuth, FB_File, FB_UserData,
} from "../../../functions/src/shareCode/Share_S_Classes";
import {re_hasLetter_fb, re_hasNumber_fb, re_validEmailAddress_fb} from "@/scripts/S_RegularExp";
import FcpcAvatarGenerator from "@/components/complex/TqAvatarGenerator";
import {validator_arrayEnum_fb, validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import FcErrorInput from "@/components/basic/TqErrorInput";
import TqCheckbox from "@/components/basic/TqCheckbox";
import {helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";
import TqBtnApprove from "@/components/basic2/TqBtnApprove";
import TqLink from "@/components/basic/TqLink";
import currentWebVersion_o from "../../../currentVersion.json";

export default {
    name: "TqLogin",
    components: {
        TqLink,
        TqBtnApprove,
        TqCheckbox,
        FcErrorInput,
        FcpcAvatarGenerator,
        TqPopup,
        TqAvatar,
        TqLoaderContainer,
        TqImage
    },
    props:{
        p_system_langCode_e:{
            type: String,
            require:true,
            validator(val){
                return validator_enum_fb(enum_langCodes, val)
            }
        },
        p_fbAuth_c:{
            type : FB_FbAuth,
            require: true,
        },
        p_upgradeUser_b: {
            type : Boolean,
            default: false,
        },
        p_hideLoginOption_ae:{
          default: () => [],
          validator(val){
            return validator_arrayEnum_fb(val, enum_langCodes)
            }          
        },
        p_showGuestOption_b:{
          type: Boolean,
          default: true,
        },

    },
    data(){
        return {
            local_currentWebVersion_o   : currentWebVersion_o,

            showPageLoader_b : false,
            loginWithGuest_b : false,
            loginWithEmail_b : false,

            // avatar
            getFile_vf          : {val : () => {}},
            lastProviders_ae    : undefined,

            // popup
            popup_show_loginWithProviderNotice_vb : {val : false},
            popup_show_notificationResetEmail_vb   : {val : false},
            popup_show_forgotPassword_vb    : {val : false},
            popup_show_avatar_generator_vb  : {val : false},

            // create user
            email_s : "",
            password_s : "",

            avatar_c: new FB_UserData_Avatar({}),
            username_s : "",
            agreeToTos_b : false,

            // imports
            ass_strings             : ass_strings,

            enum_inputType          : enum_inputType,
            enum_moveToOptions      : enum_moveToOptions,
            enum_loginMethods       : enum_loginMethods,

            ass_img_mail_w          : ass_img_mail_w,
            ass_img_mail_b2         : ass_img_mail_b2,
            ass_img_user_w          : ass_img_user_w,
            ass_img_user_b          : ass_img_user_b,
            ass_img_lock_w          : ass_img_lock_w,
            ass_img_google_w        : ass_img_google_w,
            ass_img_google_c        : ass_img_google_c,
            ass_img_facebook_w      : ass_img_facebook_w,
            ass_img_facebook_c      : ass_img_facebook_c,
            ass_img_leftArrow_w     : ass_img_arrow_left_w,
            ass_img_arrow_left_b     : ass_img_arrow_left_b,

        }
    },
    computed:{
        co_checkInput_email_s(){

            if ( this.email_s != null && !re_validEmailAddress_fb(this.email_s)) {
                return ass_strings.fourWords_emailAddressIsntValid[this.p_system_langCode_e]
            }

            return null

        },
        co_checkInput_username_s(){

            if (this.username_s == null || this.username_s.length < 3) {
                return ass_strings.sentence_inputErrorUsername3Letters[this.p_system_langCode_e]
            }

            return null
        },
        co_checkInput_password_fs(){


            if(this.co_checkInput_email_s){
                return null
            }

            if(this.password_s != null){
                if ( this.password_s.length < 6) {
                    return ass_strings.sentence_inputErrorPass6Letters[this.p_system_langCode_e]
                }

                if (!re_hasLetter_fb(this.password_s)) {
                    return ass_strings.sentence_inputErrorPass1Letter[this.p_system_langCode_e]
                }

                if (!re_hasNumber_fb(this.password_s)) {
                    return ass_strings.sentence_inputErrorPass1Num[this.p_system_langCode_e]
                }
            }


            return null
        },
        co_langCodeRtl_b(){
            return helper_getDirectionByLangCode_fe(this.p_system_langCode_e) === enum_directions.rtl
        }
    },
    methods:{

        m_login_google_f(){

            this.showPageLoader_b = true

            let fbTokenId_uid = null
            // if exist current user upgrade current user
            if(this.p_upgradeUser_b && this.p_fbAuth_c){
                fbTokenId_uid = this.p_fbAuth_c.fa_idToken_uid
            }

            serverAuth_login_google_fp(fbTokenId_uid)
                .then(() => {
                    this.showPageLoader_b = false
                })
                .catch(error_e => {

                    switch(error_e){
                        case enum_loginErrors.EMAIL_EXISTS:
                            // email exist, create new user
                            serverAuth_login_google_fp()
                                .then(() => {
                                    this.showPageLoader_b = false
                                })
                            break;

                        case enum_loginErrors.popup_closed_by_user:
                            this.showPageLoader_b = false
                            break;

                        default:
                            notification_notify2({
                                title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                                text_s: ass_strings.threeWords_somethingWentWrong[this.p_system_langCode_e]})
                            this.showPageLoader_b = false

                            console.log(error_e)


                    }

                })

        },
        m_login_facebook_f(){

            this.showPageLoader_b = true

            let fbTokenId_uid = null
            // if exist current user upgrade current user
            if(this.p_upgradeUser_b && this.p_fbAuth_c){
                fbTokenId_uid = this.p_fbAuth_c.fa_idToken_uid
            }

            serverAuth_login_facebook_fp(fbTokenId_uid)
                .then(() => {
                    this.showPageLoader_b = false
                })
                .catch(error_e => {
                    switch(error_e){
                        case enum_loginErrors.LOGIN_WITH_GOOGLE:
                            this.popup_show_loginWithProviderNotice_vb.val = true
                            break
                        default:
                            notification_notify2({
                                title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                                text_s: ass_strings.threeWords_somethingWentWrong[this.p_system_langCode_e]})
                    }

                    this.showPageLoader_b = false
                })
        },

        // login with email
        m_login_email_f(){

            if(this.lastProviders_ae === undefined){
                this.m_login_email_checkEmail_f()
            }else{
                this.m_login_email_checkPass_f()
            }
        },
        async m_login_email_checkEmail_f(){

            // check email
            if (this.co_checkInput_email_s != null) {
                notification_notify2({
                    title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                    text_s: this.co_checkInput_email_s
                })
                return
            }

            this.showPageLoader_b = true
            this.lastProviders_ae = await serverAuth_fetchProvidersForEmail_fp(this.email_s)
            this.showPageLoader_b = false

            // link google
            if((this.lastProviders_ae.includes(enum_loginMethods.google) || this.lastProviders_ae.includes(enum_loginMethods.facebook)) && !this.lastProviders_ae.includes(enum_loginMethods.email)){
                this.popup_show_loginWithProviderNotice_vb.val = true
                this.m_login_email_backBtn_f()
            }

        },
        async m_login_email_checkPass_f() {

            // check password
            if (this.co_checkInput_password_fs != null) {
                notification_notify2({
                    title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                    text_s: this.co_checkInput_password_fs
                })
                return
            }

            this.showPageLoader_b = true

            // 1) upgrade guest to emailAndPass
            if(this.p_upgradeUser_b && this.p_fbAuth_c && this.lastProviders_ae.length === 0){

                serverAuth_linkEmailPass_fp(this.p_fbAuth_c.fa_idToken_uid, this.email_s, this.password_s, [enum_loginMethods.email, enum_loginMethods.guest])
                    .then(() => {
                        this.showPageLoader_b = false
                    })
                    .catch(() => {
                        notification_notify2({
                            title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                            text_s: ass_strings.threeWords_somethingWentWrong[this.p_system_langCode_e]})
                    })
                return

            // 2) login with email and pass
            }else{

                serverAuth_login_emailPass_fp({
                    email_s: this.email_s,
                    password_s: this.password_s,
                    newUser_b: this.lastProviders_ae.length === 0
                }).then(() => {
                    this.showPageLoader_b = false
                }).catch(error_s => {
                    this.showPageLoader_b = false

                    switch(error_s){
                        case enum_loginErrors.INVALID_PASSWORD:
                            notification_notify2({
                                title_s: ass_strings.oneWord_error[this.p_system_langCode_e],
                                text_s: ass_strings.twoWords_wrongPassword[this.p_system_langCode_e]})
                            break;

                        default:
                            notification_notify2({
                                title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                                text_s: ass_strings.threeWords_somethingWentWrong[this.p_system_langCode_e]})
                    }

                })
            }

        },
        m_login_email_resetPass_f(){

            // check email
            if(this.co_checkInput_email_s != null){
                notification_notify2({title_s: ass_strings.oneWord_notice[this.p_system_langCode_e], text_s: this.co_checkInput_email_s})
                return
            }

            this.popup_show_forgotPassword_vb.val = false

            // check reset password
            return serverAuth_resetPassword_fp(this.email_s).then(() => {
                this.popup_show_notificationResetEmail_vb.val = true
            }).catch((err) => {
                console.log(err)
            })
        },
        m_login_email_backBtn_f(){
            this.loginWithEmail_b=false
            this.lastProviders_ae = undefined
        },

        // guest and userinfo
        m_userInfo_clickContinue_f() {

            if(this.co_checkInput_username_s != null){
                notification_notify2({title_s: ass_strings.oneWord_notice[this.p_system_langCode_e], text_s: this.co_checkInput_username_s})
                return
            }

            if(!this.agreeToTos_b){
                notification_notify2({title_s: ass_strings.oneWord_error[this.p_system_langCode_e], text_s: ass_strings.sentence_pleaseApproveTheTerms[this.p_system_langCode_e]})
                return
            }

            this.showPageLoader_b = true

            // login as guest
            if(this.loginWithGuest_b){
                serverAuth_login_guest_fp()
                    .then((fbAuth_c) => {
                        this.m_userInfo_createUserData_f(fbAuth_c)
                    })
            // regular login
            }else{
                this.m_userInfo_createUserData_f(this.p_fbAuth_c)
            }

        },
        m_userInfo_createUserData_f(fbAuth_c){

            let newUserData_c = new FB_UserData({
                ud_userId_uid: fbAuth_c.fa_userId_uid,
                ud_name_s: this.username_s,
                ud_email_s: fbAuth_c.fa_email_s,
                ud_avatar_c: this.avatar_c,
                ud_loginMethods_ae : [fbAuth_c.fa_lastLoginMethods_e],
                ud_approveCooliesPolicyVersion_s : this.local_currentWebVersion_o.cookiesVersion,
                ud_approveTermsOfUseVersion_s : this.local_currentWebVersion_o.termsOfUseVersion,
            })

            serverAuth_currentUserData_update_f(newUserData_c, () => {})
            notification_notify2({title_s: ass_strings.fourWords_welcomeToTravelQuest[this.p_system_langCode_e]})
        },

        // more actions
        m_avatarPopup_clickTheApproveBtn_f(){
            this.popup_show_avatar_generator_vb.val=false

            this.getFile_vf.val((file_c) =>{
                this.avatar_c.cuda_imgFile_c = file_c
            })
        },




    },

    watch:{
        p_fbAuth_c :{
            handler(){
                if(this.p_fbAuth_c && this.p_fbAuth_c.fa_lastLoginMethods_e !== enum_loginMethods.guest){
                    this.avatar_c = new FB_UserData_Avatar({
                        cuda_avatarImage_b  : this.p_fbAuth_c.fa_photoUrl_s != null,
                        cuda_imgFile_c      : new FB_File({
                            fi_url_s : this.p_fbAuth_c.fa_photoUrl_s
                        }),
                    })
                    this.username_s = this.p_fbAuth_c.fa_name_s
                }
            },
            immediate: true,
            deep: true,
        },
    }
}
</script>

<style scoped lang="scss">


.lc_or{
    transform: translate(0, -24px);
    //margin-top: -28px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    //line-height: 32px;
    text-align: center;
}

/* bottom bar*/
.lc_bottom_hr {
    margin: 8px -8px;
}






</style>
